import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="schedule-toggle"
// Shows/hides the schedule-mode-specific inputs for a DataSource run-times
// schedule, and lets the user add custom run times. Presentational only — the
// server (DataSources::ScheduleParams) translates the chosen mode + fields into
// run_at_minutes, so no time math happens here.
export default class extends Controller {
  static targets = [
    "mode",
    "dailyOptions",
    "everyNOptions",
    "customOptions",
    "customList",
  ];

  connect() {
    this.modeChanged();
  }

  modeChanged() {
    const mode = this.selectedMode();
    this.toggle(this.hasDailyOptionsTarget ? this.dailyOptionsTarget : null, mode === "daily");
    this.toggle(this.hasEveryNOptionsTarget ? this.everyNOptionsTarget : null, mode === "every_n_hours");
    this.toggle(this.hasCustomOptionsTarget ? this.customOptionsTarget : null, mode === "custom");
  }

  addCustomTime() {
    const input = document.createElement("input");
    input.type = "time";
    input.step = "300";
    input.name = "data_source[custom_times][]";
    input.className = "block rounded-md border-gray-300 shadow-sm sm:text-sm";
    this.customListTarget.appendChild(input);
  }

  selectedMode() {
    const checked = this.modeTargets.find((el) => el.checked);
    return checked ? checked.value : "off";
  }

  toggle(el, visible) {
    if (!el) return;
    el.classList.toggle("hidden", !visible);
  }
}
